/**
 * Converts default JSON structure of bloomreach resource API to flat format:
 * { [key: string (e.g. products)]: Object<key:value> }
 */ function flattenResources(resources) {
    var ref;
    const { bundles  } = (ref = resources === null || resources === void 0 ? void 0 : resources.resourceBundles) !== null && ref !== void 0 ? ref : {};
    const flatBundles = {};
    for(const key in bundles){
        if (bundles.hasOwnProperty(key)) {
            // get last part of key to create a shorter key in the new object
            const newKey = key.split('.')[key.split('.').length - 1];
            const { properties ={}  } = bundles[key];
            flatBundles[newKey] = properties;
        }
    }
    return flatBundles;
}

export { flattenResources };
//# sourceMappingURL=flatten-resources.js.map
